import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h3>Page Not Found</h3>
    </div>
  );
};

export default ErrorPage;
